import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Landing from "./components/Landing";
import NotFound from "./components/PageNotFound";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Contact from "./components/contactus";
import Service from "./components/Service";
import Employee from "./components/Employee";
import Covid from "./components/Covid";
import Referal from "./components/ReferralForm";
import EVVPage from "./components/EvvPage";
import PCA from "./components/PCA";
import CFSS from "./components/CFSS";
import FAQ from "./components/FAQs";
import Review from "./components/Review";
import TawkToChat from "./components/TawkToChat";
import LanguageSwitcher from "./components/googelTranslator";
import Accessibility from "./components/Accessibility";
import "bootstrap/dist/css/bootstrap.min.css";
import UserWayWidget from "./components/UserWayWidget";
import Loader from "./components/Loader";
import Usertracking from "./components/Usertracking";
import PCAApplicationForm from "./components/Employment";
import { toast, ToastContainer } from "react-toastify";
import DashboardPage from "./components/DashBoard";
import ProfilePage from "./HrDashboard/components/Profile/Profile";
import HRFormPage from "./HrDashboard/components/Form/FormDetails";
import LoginPage from "./Auths/Login";
import SignupPage from "./Auths/SignUp";
import VerificationPage from "./Auths/Verificaation/verify";
import FormsPage from "./HrDashboard/components/Form/Forms";
import PromoteToHR from "./Admin/promoteToHr";
import ApplyForHR from "./User/applyAsAHR";

function App() {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    // Show the loader for 5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

  if (loading) {
    return <Loader />; // Show the loader before rendering the app
  }
  const handleSearch = () => {
    if (searchTerm.trim() !== "") {
      if(searchTerm.trim()==='home' || searchTerm.trim()==='Home'){
        navigate(`/`);
        setSearchTerm('');
      }
      else if(searchTerm.trim()==='about' || searchTerm.trim()==='About'){
        navigate(`/about`);
        setSearchTerm('');
      }
      else if(searchTerm.trim()==='contact' || searchTerm.trim()==='Contact'){
        navigate(`/contact-us`);
        setSearchTerm('');
      }
      else if(searchTerm.trim()==='service' || searchTerm.trim()==='Service'){
        navigate(`/service`);
        setSearchTerm('');
      }
      else if(searchTerm.trim()==='career' || searchTerm.trim()==='Career'){
        navigate(`/career`);
        setSearchTerm('');
      }
      else if(searchTerm.trim()==='covid' || searchTerm.trim()==='Covid'){
        navigate(`/covid-19`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='referral' || searchTerm.trim()==='Referral'){
        navigate(`/referral`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='evv' || searchTerm.trim()==='EVV'){
        navigate(`Resource/evv`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='pca' || searchTerm.trim()==='PCA'){
        navigate(`/service/PCA`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='cfss' || searchTerm.trim()==='CFSS'){
        navigate(`/service/PCA`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='faq' || searchTerm.trim()==='FAQ'){
        navigate(`Resource/FAQ`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='review' || searchTerm.trim()==='Review'){
        navigate(`/review`);
      setSearchTerm('');
      }
      else if(searchTerm.trim()==='form' || searchTerm.trim()==='PCA form'){
        const accesscode= prompt("Please enter the access code:");
        if(accesscode === 'samah123'){
          toast.success('Access granted. Redirecting to the PCA application form.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
            setTimeout(() => {
              navigate(`/quil`);
            }, 3000);  
        }
      else{
        toast.error('Incorrect access code. Please try again.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,

          draggable: true,
          progress: undefined,
          theme: "light",
          });
        
      }
      setSearchTerm('');
      }
      else{
        navigate(`*`);
      }
    } else {
      window.location.pathname = (`*`);
    }
  };

  return (
    <div className="google" style={{ position: "relative" }}>
      {/* Google Translator at the very top */}
      <div
        style={{
          position: "static",
          top: 0,
          width: "100%",
          backgroundColor: "#0095fa",
          zIndex: 1000,
          textAlign: "center",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          color: "white",
          borderBottom: "1px solid white",
          padding: "0px 25px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <LanguageSwitcher />
        </div>

        <div style={{ display: "flex", alignItems: "center", color: "white", marginTop: "10px", position: "relative" }}>
          <input
            type="search"
            placeholder="Search"
            id="search"
            className="form-control"
            width={"90%"}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="btn btn-warning" onClick={handleSearch} id="search-button">
            Search
          </button>
        </div>
      </div>

      {/* Main Content */}
      <Navbar />
      <UserWayWidget />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/why-samah-homes" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/service" element={<Service />} />
        <Route path="/career" element={<Employee />} />
        <Route path="/quil" element={<PCAApplicationForm />} />
        <Route path="/covid-19" element={<Covid />} />
        <Route path="/Refferal-form" element={<Referal />} />
        <Route path="/Resource/evv" element={<EVVPage />} />
        <Route path="/service/PCA" element={<PCA />} />
        <Route path="/service/CFSS" element={<CFSS />} />
        <Route path="/Resource/FAQ" element={<FAQ />} />
        <Route path="/review" element={<Review />} />
        <Route path="/hr/dashboard" element= {<DashboardPage />} />
        <Route path="/hr/form" element={<FormsPage />} /> 
        <Route path="/hr/form/:uuid" element={<HRFormPage />} /> 
        <Route path="/hr/dashboard/profile" element={ <ProfilePage/> } />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sign-up" element={<SignupPage />} />

        <Route path="/verify-token/:token" element={<VerificationPage />} />

         <Route path="/admin/promote-to-hr/:userId" element={<PromoteToHR />} />

         <Route path="/apply-hr" element={<ApplyForHR />} />
        {/* 404 Page - Handles all undefined routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Usertracking/>
      <TawkToChat />
    </div>
  );
}

export default App;
